<template>
  <collapsible-widget title="WARSTWY TYMCZASOWE" :accordion="accordion" :default-expanded="true" :expand-widget="expandWidget">
    <b-list-group id="temporary-layers-list" v-if="$store.getters.temporaryLayers.length">
      <b-list-group-item v-for="layer in $store.getters.temporaryLayers" :key="layer.title" class="temporary-layers-list-group-item">
        <temporary-layer :layer="layer"></temporary-layer>
      </b-list-group-item>
    </b-list-group>

    <b-modal v-model="showModal" centered title="Dodaj warstwę" size="lg" @ok.prevent="addLayer" ok-title="Dodaj" cancel-title="Anuluj" @hidden="clear">
        <b-form @submit.stop.prevent="addLayer">
          <b-form-row>
            <b-col cols="12">
              <b-alert variant="danger" :show="showError"><strong>Uwaga.</strong> Formularz zawiera błędy</b-alert>
            </b-col>
          </b-form-row>
          <b-form-row v-if="showError">
            <b-col offset="3" cols="9">
              <small class="text-danger">Należy podać nazwę warstwy</small>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="3">
              <label>Nazwa warstwy</label>
            </b-col>
            <b-col cols="9">
              <b-input maxlength="66" class="col-md-12" v-model="layerName" placeholder="Wpisz" :state="validated && layerNameIsEmpty ? false : null"></b-input>
            </b-col>
          </b-form-row>
        </b-form>
    </b-modal>
    <loading-overlay :active="$store.getters.temporaryLayersModuleLoading" :is-full-page="true"></loading-overlay>
  </collapsible-widget>
</template>

<script>
import TemporaryLayer from "./TemporaryLayer";
import CollapsibleWidget from "./CollapsibleWidget";
import LoadingOverlay from 'vue-loading-overlay';
import { TEMPORARY_LAYER_SAVE_NAME } from "../store/actions.type";
import { TEMPORARY_LAYER_MODAL_HIDDEN } from '../store/mutations.type';

export default {
  props: {
    accordion: {
      type: String,
      default: 'panel'
    },
    expandWidget: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TemporaryLayer,
    CollapsibleWidget,
    LoadingOverlay
  },
  data() {
    return {
      validated: false,
      layerName: null
    };
  },
  computed: {
    showModal: {
      get() { return this.$store.getters.temporaryLayerSaveModalVisibility; },
      set(value) { if (!value) this.$store.commit(TEMPORARY_LAYER_MODAL_HIDDEN); }
    },
    layerNameIsEmpty() {
      return !this.layerName;
    },
    showError() {
      return this.validated && this.layerNameIsEmpty;
    }
  },
  methods: {
    async addLayer() {
      this.validated = true;

      if (!this.layerNameIsEmpty) {
        await this.$store.dispatch(TEMPORARY_LAYER_SAVE_NAME, { name: this.layerName, userEmail: this.contextEmail });
      }
    },
    clear() {
      this.validated = false;
      this.layerName = null;
    }
  }
};
</script>